<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">BIR EXPENSE</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md9>
            <v-select
              class="mx-2"
              v-model="bir_expense_form"
              dense
              outlined
              label="BIR Form"
              :items="bir_form_items"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field v-model="schedule"
                          class="mx-2"
                          dense
                          outlined
                          label="Schedule"
                          type="date"
                          :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"

            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{alert_message}}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>

  import {mdiAlertOutline} from "@mdi/js";
  import {mapGetters} from "vuex";

  const initialState = () => {
    return {
      saving_request: false,
      alert: false,
      alert_message: '',
      bir_expense_form: '',
      schedule: '',
      bir_form_items: ['0605', '0613-UTCV', '0619-E', '1601-C', '1601-EQ', '1601E', '1604-CF', '1604-E', '1700A', '1702', '1702-Q', '1903', '2000', '2316', '2550-M', '2550-Q', '2551-M', '2551-Q', 'ANNUAL REPORT ITR', 'CHANGE ADDRESS', 'DOCUMENTARY STAMP', 'ITR FEE', 'PENALTY', 'PENALTY FOR BOOK OF ACCTS.', 'PENALTY LOSS COR', 'PROFESSIONAL FEE', 'PURCHASE', 'SALES'],
    }
  }
  export default {
    setup() {
      return {
        icons: {
          mdiAlertOutline,
        },
      }
    },
    data() {
      return initialState();
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
    },
    methods: {
      done_request() {
        this.saving_request = true
        this.alert = false
        if (this.$refs.form.validate()) {
          this.$emit('data', this.bir_expense_form + ' # ' + this.schedule)
        } else {
          this.alert = true
          this.alert_message = 'Please Fill up the field/s'
          this.saving_request = false
        }
      },
    }
  }
</script>
